<div class="maintenance-admin">
  <div class="maintenance-admin__head">
    <div>
      <h1 class="maintenance-admin__title">{{ 'maintenance.admin.title' | translate }}</h1>
      <p class="maintenance-admin__sub">{{ 'maintenance.admin.subtitle' | translate }}</p>
    </div>
    <div class="maintenance-admin__state" [ngClass]="'maintenance-admin__state--' + phase">
      <span class="maintenance-admin__state-dot"></span>
      <div>
        <div class="maintenance-admin__state-label">{{ 'maintenance.admin.phase.' + phase | translate }}</div>
        <div class="maintenance-admin__state-desc">
          @switch (phase) {
            @case ('prewarn') { {{ 'maintenance.admin.phaseDesc.prewarn' | translate: {minutes: minsUntilStart} }} }
            @case ('running') { {{ 'maintenance.admin.phaseDesc.running' | translate: {minutes: minsUntilEnd} }} }
            @default { {{ 'maintenance.admin.phaseDesc.' + phase | translate }} }
          }
        </div>
      </div>
    </div>
  </div>

  <div class="maintenance-admin__grid">
    <div class="maintenance-admin__card">
      <div class="maintenance-admin__row">
        <mat-form-field appearance="outline" class="maintenance-admin__field">
          <mat-label>{{ 'maintenance.admin.startDate' | translate }}</mat-label>
          <input matInput [matDatepicker]="startDatePicker" [ngModel]="startDateMoment" (ngModelChange)="onStartDateChange($event)" name="startDate" required />
          <mat-datepicker-toggle matIconSuffix [for]="startDatePicker"></mat-datepicker-toggle>
          <mat-datepicker #startDatePicker>
            <mat-datepicker-actions>
              <button mat-button matDatepickerCancel>{{ 'general.cancel' | translate }}</button>
              <button mat-flat-button matDatepickerApply>{{ 'general.apply' | translate }}</button>
            </mat-datepicker-actions>
          </mat-datepicker>
          @if (startTimeInvalid) {
            <mat-error>{{ 'maintenance.admin.validation.startFuture' | translate }}</mat-error>
          }
        </mat-form-field>
        <mat-form-field appearance="fill" class="maintenance-admin__field">
          <mat-label>{{ 'maintenance.admin.startTime' | translate }}</mat-label>
          <input matInput [matTimepicker]="startTimePicker" [ngModel]="startTimeMoment" (ngModelChange)="onStartTimeChange($event)" name="startTime" required />
          <mat-timepicker-toggle matIconSuffix [for]="startTimePicker"></mat-timepicker-toggle>
          <mat-timepicker #startTimePicker></mat-timepicker>
        </mat-form-field>
      </div>
      <div class="maintenance-admin__row">
        <mat-form-field appearance="outline" class="maintenance-admin__field">
          <mat-label>{{ 'maintenance.admin.endDate' | translate }}</mat-label>
          <input matInput [matDatepicker]="endDatePicker" [ngModel]="endDateMoment" (ngModelChange)="onEndDateChange($event)" name="endDate" required />
          <mat-datepicker-toggle matIconSuffix [for]="endDatePicker"></mat-datepicker-toggle>
          <mat-datepicker #endDatePicker>
            <mat-datepicker-actions>
              <button mat-button matDatepickerCancel>{{ 'general.cancel' | translate }}</button>
              <button mat-flat-button matDatepickerApply>{{ 'general.apply' | translate }}</button>
            </mat-datepicker-actions>
          </mat-datepicker>
          @if (endTimeInvalid) {
            <mat-error>{{ 'maintenance.admin.validation.endAfterStart' | translate }}</mat-error>
          }
        </mat-form-field>
        <mat-form-field appearance="fill" class="maintenance-admin__field">
          <mat-label>{{ 'maintenance.admin.endTime' | translate }}</mat-label>
          <input matInput [matTimepicker]="endTimePicker" [ngModel]="endTimeMoment" (ngModelChange)="onEndTimeChange($event)" name="endTime" required />
          <mat-timepicker-toggle matIconSuffix [for]="endTimePicker"></mat-timepicker-toggle>
          <mat-timepicker #endTimePicker></mat-timepicker>
        </mat-form-field>
      </div>

      <mat-form-field appearance="outline" class="maintenance-admin__field maintenance-admin__field--narrow">
        <mat-label>{{ 'maintenance.admin.warningMinutes' | translate }}</mat-label>
        <input matInput type="number" [(ngModel)]="maintenanceWindow.warningMinutes" name="warningMinutes" min="5" required />
        <mat-hint>{{ 'maintenance.admin.warningHint' | translate }}</mat-hint>
        @if (warningMinutesInvalid) {
          <mat-error>{{ 'maintenance.admin.validation.warningMin' | translate }}</mat-error>
        }
      </mat-form-field>

      <mat-form-field appearance="outline" class="maintenance-admin__field">
        <mat-label>{{ 'maintenance.admin.infoText' | translate }}</mat-label>
        <textarea matInput [(ngModel)]="maintenanceWindow.infoText" name="infoText" rows="4" maxlength="500" required></textarea>
      </mat-form-field>

      <div class="maintenance-admin__toggles">
        <button type="button" class="maintenance-admin__toggle" [class.maintenance-admin__toggle--on]="maintenanceWindow.active" (click)="maintenanceWindow.active = !maintenanceWindow.active" role="switch" [attr.aria-checked]="maintenanceWindow.active">
          <span class="maintenance-admin__toggle-track">
            <span class="maintenance-admin__toggle-knob">
              @if (maintenanceWindow.active) { <mat-icon class="maintenance-admin__toggle-ic">check</mat-icon> }
            </span>
          </span>
          <span class="maintenance-admin__toggle-label">{{ 'maintenance.admin.active' | translate }}</span>
        </button>
        <button type="button" class="maintenance-admin__toggle" [class.maintenance-admin__toggle--on]="maintenanceWindow.autoLogout" (click)="maintenanceWindow.autoLogout = !maintenanceWindow.autoLogout" role="switch" [attr.aria-checked]="maintenanceWindow.autoLogout">
          <span class="maintenance-admin__toggle-track">
            <span class="maintenance-admin__toggle-knob">
              @if (maintenanceWindow.autoLogout) { <mat-icon class="maintenance-admin__toggle-ic">check</mat-icon> }
            </span>
          </span>
          <span class="maintenance-admin__toggle-label">{{ 'maintenance.admin.autoLogout' | translate }}</span>
        </button>
      </div>

      @if (!isFormValid && (maintenanceWindow.startTime || maintenanceWindow.endTime || maintenanceWindow.infoText)) {
        <div class="maintenance-admin__warn-msg">
          <mat-icon>warning_amber</mat-icon>
          {{ 'maintenance.admin.validation.incomplete' | translate }}
        </div>
      }

      <div class="maintenance-admin__actions">
        <button class="maintenance-admin__btn-ghost" (click)="showPreview = true" type="button">
          <mat-icon>visibility</mat-icon>
          {{ 'maintenance.admin.preview' | translate }}
        </button>
        <button class="maintenance-admin__btn-primary" (click)="save()" type="button" [disabled]="!isFormValid || saving">
          <mat-icon>save</mat-icon>
          {{ 'general.save' | translate }}
        </button>
        @if (hasExistingWindow) {
          @if (confirmingDelete) {
            <span class="maintenance-admin__confirm-label">{{ 'maintenance.admin.confirmDelete' | translate }}</span>
            <button class="maintenance-admin__btn-danger" (click)="delete()" type="button">
              <mat-icon>check</mat-icon>
              {{ 'general.yes' | translate }}
            </button>
            <button class="maintenance-admin__btn-ghost" (click)="confirmingDelete = false" type="button">
              {{ 'general.cancel' | translate }}
            </button>
          } @else {
            <button class="maintenance-admin__btn-danger" (click)="confirmingDelete = true" type="button">
              <mat-icon>delete</mat-icon>
              {{ 'general.delete' | translate }}
            </button>
          }
        }
      </div>
    </div>

    <div class="maintenance-admin__side">
      <div class="maintenance-admin__side-title">{{ 'maintenance.admin.sideTitle' | translate }}</div>
      <div class="maintenance-admin__mini-toast">
        <span class="maintenance-admin__mini-toast-ic">
          <span class="maintenance-admin__mini-toast-dot"></span>
          <mat-icon>group</mat-icon>
        </span>
        <div class="maintenance-admin__mini-toast-body">
          <div class="maintenance-admin__mini-toast-title">{{ 'maintenance.banner.warningLabel' | translate }}</div>
          <div class="maintenance-admin__mini-toast-text">{{ 'maintenance.banner.warningText' | translate: {start: (maintenanceWindow.startTime | date: 'HH:mm'), minutes: maintenanceWindow.warningMinutes} }}@if (maintenanceWindow.autoLogout) { {{ 'maintenance.banner.autoLogout' | translate }}}</div>
        </div>
      </div>
      <div class="maintenance-admin__mini-lock">
        <div class="maintenance-admin__mini-art">
          <svg viewBox="0 0 24 24" width="30" height="30" fill="currentColor"><path d="M12 2a4 4 0 0 0-4 4v1h8V6a4 4 0 0 0-4-4Zm-7 6a1 1 0 0 0-1 1 8 8 0 0 0 6 7.75V19H8a1 1 0 1 0 0 2h8a1 1 0 1 0 0-2h-2v-2.25A8 8 0 0 0 20 9a1 1 0 0 0-1-1H5Z"/></svg>
        </div>
        <div class="maintenance-admin__mini-h">{{ 'maintenance.page.title' | translate }}</div>
        <div class="maintenance-admin__mini-info">{{ maintenanceWindow.infoText || '—' }}</div>
        <div class="maintenance-admin__mini-end">{{ 'maintenance.admin.end' | translate }}: {{ maintenanceWindow.endTime | date: 'dd.MM.yyyy HH:mm' }}</div>
      </div>
      <ul class="maintenance-admin__steps">
        <li>
          <span class="maintenance-admin__step-num">1</span>
          {{ 'maintenance.admin.step1' | translate: {minutes: maintenanceWindow.warningMinutes ?? 0} }}
        </li>
        <li>
          <span class="maintenance-admin__step-num">2</span>
          {{ (maintenanceWindow.autoLogout ? 'maintenance.admin.step2AutoLogout' : 'maintenance.admin.step2') | translate }}
        </li>
        <li>
          <span class="maintenance-admin__step-num">3</span>
          {{ 'maintenance.admin.step3' | translate }}
        </li>
      </ul>
    </div>
  </div>

  @if (showPreview) {
    <div class="maintenance-admin__overlay">
      <div class="maintenance-admin__preview-bar">
        <span><mat-icon class="maintenance-admin__preview-ic">visibility</mat-icon> {{ 'maintenance.admin.previewBar' | translate }}</span>
        <button class="maintenance-admin__btn-text" (click)="showPreview = false" type="button">{{ 'general.cancel' | translate }}</button>
      </div>
      <div class="maintenance-admin__lock-body">
        <div class="maintenance-admin__art">
          <svg viewBox="0 0 24 24" width="56" height="56" fill="currentColor"><path d="M12 2a4 4 0 0 0-4 4v1h8V6a4 4 0 0 0-4-4Zm-7 6a1 1 0 0 0-1 1 8 8 0 0 0 6 7.75V19H8a1 1 0 1 0 0 2h8a1 1 0 1 0 0-2h-2v-2.25A8 8 0 0 0 20 9a1 1 0 0 0-1-1H5Z"/></svg>
          <svg viewBox="0 0 24 24" width="30" height="30" fill="currentColor" class="maintenance-admin__gear"><path d="M12 8a4 4 0 1 0 0 8 4 4 0 0 0 0-8Zm0 2.5a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3Z"/><path d="M19.4 13a7.6 7.6 0 0 0 0-2l1.7-1.3-1.6-2.8-2 .8a7.5 7.5 0 0 0-1.7-1l-.3-2.1H10l-.3 2.1a7.5 7.5 0 0 0-1.7 1l-2-.8L4.4 9.7 6.1 11a7.6 7.6 0 0 0 0 2L4.4 14.3l1.6 2.8 2-.8c.5.4 1.1.7 1.7 1l.3 2.1h3.5l.3-2.1c.6-.3 1.2-.6 1.7-1l2 .8 1.6-2.8L19.4 13Z" opacity=".55"/></svg>
        </div>
        <h1 class="maintenance-admin__lock-title">{{ 'maintenance.page.title' | translate }}</h1>
        <p class="maintenance-admin__lock-lead">{{ 'maintenance.page.info' | translate }}</p>
        @if (maintenanceWindow.infoText) {
          <div class="maintenance-admin__lock-info">{{ maintenanceWindow.infoText }}</div>
        }
        <div class="maintenance-admin__lock-end">{{ 'maintenance.page.end' | translate: {time: (maintenanceWindow.endTime | date: 'dd.MM.yyyy HH:mm')} }}</div>
        <p class="maintenance-admin__lock-hint">{{ 'maintenance.page.redirect' | translate }}</p>
      </div>
    </div>
  }
</div>
